module.exports = __webpack_public_path__ + "static/media/board-secret.97a712a5.svg";